<template src="./TestGridOverlay.html"></template>
<script>
export default {
  name: 'TestGridOverlay',
  created() {
    document.addEventListener('keydown', this.onKeyDown);
  },
  destroyed() {
    document.removeEventListener('keydown', this.onKeyDown);
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    onKeyDown(e) {
      const code = e.keyCode;

      if (code === 76 && e.ctrlKey) {
        this.visible = !this.visible;
      }
    }
  }
};
</script>
<style src="./TestGridOverlay.scss" lang="scss" scoped></style>
